export const cacheDict = {
  'port-mapping-types': '/secured/estimation-api/port-mapping-type-ref-data',
  'vessel-sizes': '/secured/vessel-sizes-ref-data',
  'vessel-types': '/secured/vessel-types-ref-data'
};
